import { SortingState, Updater } from '@tanstack/react-table';
import { useCallback, useState } from 'react';
import { useUserConfigContext } from './useUserConfigContext';

/**
 * Spaltensortierung einer Tabelle, gespeichert in der UserConfig.
 *
 * Bis zur Umstellung wurde die Sortierung zwar gelesen, aber nie geschrieben —
 * jetzt speichert der Setter sie (der Store entprellt den Request).
 */
export function useColumnsSort(tableName: string, initial?: SortingState) {
  const userConfig = useUserConfigContext();

  const [sorting, setSorting] = useState<SortingState>(
    userConfig.getTableConfig(tableName)?.columnsSort ?? initial ?? [],
  );

  const saveSorting = useCallback(
    (updaterOrValue: Updater<SortingState>) => {
      setSorting((previous) => {
        const next = typeof updaterOrValue === 'function' ? updaterOrValue(previous) : updaterOrValue;
        userConfig.upsertTableConfig(tableName, { columnsSort: next });
        return next;
      });
    },
    [tableName, userConfig],
  );

  return { sorting, saveSorting };
}
